import React, {useState, useEffect} from 'react';
import t from "../../../translate";
import { Editor } from '@tinymce/tinymce-react';
import ContentEditable from "react-contenteditable";
import ReactTooltip from 'react-tooltip'
import { v4 as uuidv4 } from "uuid";
import { getClone } from "../../../utils";

// Import TinyMCE Core
import 'tinymce/tinymce';

// Import Theme, Icons, and Model
import 'tinymce/themes/silver'; // Default theme
import 'tinymce/icons/default'; // Default icons
//import 'tinymce/models/dom';    // DOM model

// Import Required Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';

const Ranges = (props) => {

  const [ranges, setRanges] = useState([])

  useEffect(() => {
    if (typeof props.ranges != "undefined" && props.ranges != "") {
      setRanges(props.ranges);
    }
  }, [props]);

  function addRange(){
    let rangesToSet = ranges;
    rangesToSet.push({min:"",max:"",feedback:"", id:uuidv4()})
    updateRanges(rangesToSet)
  }

  function deleteRange(index){
    let rangesToSet = ranges;
    rangesToSet.splice(index, 1);
    updateRanges(rangesToSet)
  }

  function updateRanges(rangesToSet){
    setRanges(rangesToSet)
    props.setStateHandler({ranges: rangesToSet})
  }

  function updateMin(min, index){
    let rangesToSet = ranges;
    rangesToSet[index].min = min
    updateRanges(rangesToSet)
  }
  function updateMax(max, index){
    let rangesToSet = ranges;
    rangesToSet[index].max = max
    updateRanges(rangesToSet)
  }
  function updateFeedback(index, content){
    let rangesToSet = ranges;
    rangesToSet[index].feedback = content
    updateRanges(rangesToSet)
  }
  function copyRange(index){
    let rangesToSet = [...ranges];
    let toCopy = getClone(rangesToSet[index])
    toCopy.id = uuidv4()
    rangesToSet.splice(index, 0, JSON.parse(JSON.stringify(toCopy)));
    updateRanges(rangesToSet)
  }
  function swapRange(indexA, indexB){
    let rangesToSet = ranges;
    var a = rangesToSet[indexA];
    rangesToSet[indexA] = rangesToSet[indexB];
    rangesToSet[indexB] = a;
    updateRanges(rangesToSet)
  }

  return(
    <div>
      <div className="minmax">
        <span>{t("Eindscore ")}</span>
        <span>{t('min')} {props.range["rangeMin"]} </span>
        <span>{t('max')} {props.range["rangeMax"]} </span>
      </div>
      <div className="ranges">
        {ranges.map((range, index)=>
          <div key={range.id} className="range">
            <div className="options">
              {index != 0 ? (
                <button
                  type="button"
                  onClick={() => swapRange(index, index - 1)}
                  data-tip={t("Naar boven")}
                >
                  <i className="fa fa-chevron-up"></i>
                </button>
              ) : (
                ""
              )}
              {index != ranges.length - 1 ? (
                <button
                  type="button"
                  onClick={() => swapRange(index, index + 1)}
                  data-tip={t("Naar beneden")}
                >
                  <i className="fa fa-chevron-down"></i>
                </button>
              ) : (
                ""
              )}
              <button type="button" onClick={() => copyRange(index)} data-tip={t("Kopieer range")}>
                <i className="fa fa-copy"></i>
              </button>
              <button type="button" onClick={() => deleteRange(index)} data-tip={t("Verwijder range")}>
                <i className="fa fa-trash"></i>
              </button>
            </div>
            <table className="min_max">
              <tbody>
                <tr>
                  <td>
                    Feedback bij een score
                  </td>
                  <td>
                    van
                  </td>
                  <td>
                    <ContentEditable
                      html={range.min}
                      disabled={false}
                      onChange={e => updateMin(e.target.value, index)}
                      className=""
                      placeholder="Min"
                    />
                  </td>
                  <td>
                    tot en met
                  </td>
                  <td>
                    <ContentEditable
                      html={range.max}
                      disabled={false}
                      onChange={e => updateMax(e.target.value, index)}
                      className=""
                      placeholder="Max"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="editor_holder">
            <Editor
              inline
              value={range.feedback}
              init={{
                base_url: '/tinymce', // Base path for all TinyMCE resources
                skin_url: '/tinymce/skins/ui/oxide',
                content_css: '/tinymce/skins/content/default/content.css',
                menubar:false,
                plugins: 'link image code lists advlist',
                toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | fontsizeselect | link | removeformat | code",
                setup: editor => {
                  //Keep bg image dark if on focus
                  editor.on('keydown', function(e){

                    if(e.target.nextSibling.classList)
                    {
                      if(e.target.nextSibling.classList.contains('placeholder_editor')){
                        e.target.nextSibling.classList.add("hide")
                      }
                    }

                  });
                  editor.on('focus', function(e){

                  });
                  //Remove dark bg on focus out
                  editor.on('blur', function(e){

                  });
                }
                /*myCustomToolbarButton
                setup: (editor) => {
                  editor.ui.registry.addButton('myCustomToolbarButton', {
                    text: 'My Custom Button',
                    onAction: () => props.showMediaLibrary()
                  });

                }  */
              }}
              onEditorChange={(content, editor) => updateFeedback(index, content)}
              />

              {range.feedback == "" ?
                <div className="placeholder_editor">
                  Plaats hier de feedback...
                </div>
              :''}

            </div>

            
          </div>
        )}
      </div>
      <span className="add btn btn-primary showOnHover" onClick={(e) => addRange('')} >{t("Item toevoegen")} <i className="fa fa-plus"></i></span>
    </div>
  );
}

export default Ranges
